<template>
  <div class="flex">
    <h2>{{ $t('intensity.intensities') }}</h2>
    <div class="white-button fit bold" @click="showAddIntensityModal = true">
      + {{ $t('intensity.add') }}
    </div>
  </div>

  <div class="white-container-item">
    <div class="snackbar info">
      <div class="letter-circle">i</div>
      <div>
        {{ $t('intensity.description') }}
      </div>
    </div>
  </div>
  <div class="white-container-item">
    <div v-if="!company.intensities" class="grey-text medium">
      {{ $t('intensity.noIntensity') }}
    </div>
    <div v-else v-for="intensity in company.intensities" :key="intensity" class="flex left">
      <p>{{ intensity }}</p>

      <font-awesome-icon :icon="['fas', 'pen']" class="pointer" @click="changeIntensityModal(intensity)"/>
      <font-awesome-icon :icon="['fas', 'trash-alt']" class="pointer" @click="deleteIntensityConfirmation(intensity)"/>
    </div>
  </div>

  <changeIntensityModal v-if="showChangeIntensityModal" :propsIntensity="intensityToChange" @close="showChangeIntensityModal = false" @changeIntensity="changeIntensity" />
  <addIntensityModal v-if="showAddIntensityModal" @close="showAddIntensityModal = false" @addIntensity="addIntensity" />
  <deleteIntensityModal v-if="showDeleteModal" :intensity="intensityToChange" @close="showDeleteModal = false" @deleteIntensity="deleteIntensity" />

</template>
<script>
// import instance from '../../main';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import addIntensityModal from './addIntensityModal.vue'
import deleteIntensityModal from './deleteIntensityModal.vue'
import changeIntensityModal from './changeIntensityModal.vue'

export default {
  components: {
    addIntensityModal, FontAwesomeIcon, deleteIntensityModal, changeIntensityModal
  },
  props: {
    propsCompany: Object
  },
  data() {
    return{
      isLoading: true,
      company: this.propsCompany,
      showAddIntensityModal: false,
      showChangeIntensityModal: false,
      showDeleteModal: false,
      intensityToChange: null
    }
  },
  async mounted() {

  },
  computed: {

  },
  methods: {
    addIntensity(intensity) {
      if (this.company.intensities) {
        this.company.intensities.push(intensity)
      } else {
        this.company.intensities = [intensity]
      }
      this.showAddIntensityModal = false
      this.intensityToChange = null
      this.$emit('updateCompany', this.company)
    },
    changeIntensityModal(intensity) {
      this.intensityToChange = intensity
      this.showChangeIntensityModal = true
    },
    changeIntensity(intensity) {
      this.showChangeIntensityModal = false
      this.company.intensities[this.company.intensities.indexOf(this.intensityToChange)] = intensity
      this.intensityToChange = null
      this.$emit('updateCompany', this.company)
    },
    deleteIntensityConfirmation(intensity) {
      this.intensityToChange = intensity
      this.showDeleteModal = true
    },
    deleteIntensity(intensity) {
      this.company.intensities.splice(this.company.intensities.indexOf(intensity), 1)
      this.showDeleteModal = false
      this.intensityToChange = null
      this.$emit('updateCompany', this.company)
    }

  },
  created() {

  }
}

</script>
